import React, { useEffect } from "react";
import { Link, NavLink } from "react-router-dom";

const Sidebar = () => {
  useEffect(() => {
    const handleTriggerClick = (e) => {
      e.preventDefault();
      e.stopPropagation();
      const offcanvasId = e.currentTarget.getAttribute("data-trigger");
      const offcanvasElement = document.querySelector(offcanvasId);
      if (offcanvasElement) {
        offcanvasElement.classList.toggle("show");
      }
    };

    const handleMinimizeClick = () => {
      if (window.innerWidth < 768) {
        document.body.classList.remove("aside-mini");
        document.querySelector(".navbar-aside").classList.remove("show");
      } else {
        document.body.classList.toggle("aside-mini");
      }
    };

    const triggerElements = document.querySelectorAll("[data-trigger]");
    triggerElements.forEach((element) => {
      element.addEventListener("click", handleTriggerClick);
    });

    const minimizeButton = document.querySelector(".btn-aside-minimize");
    if (minimizeButton) {
      minimizeButton.addEventListener("click", handleMinimizeClick);
    }

    return () => {
      triggerElements.forEach((element) => {
        element.removeEventListener("click", handleTriggerClick);
      });
      if (minimizeButton) {
        minimizeButton.removeEventListener("click", handleMinimizeClick);
      }
    };
  }, []);

  return (
    <div className="sidebar">
      <aside className="navbar-aside" id="offcanvas_aside">
        <div className="aside-top" style={{ backgroundColor: "#12254A" }}>
          <Link to="/" className="brand-wrap">
            <img
              src="image/axiomlogo.svg"
              style={{ height: "46px" }}
              className="logo"
              alt="logo"
            />
          </Link>
          <div>
            <button className="btn btn-icon btn-aside-minimize">
              <i className="text-muted fas fa-stream"></i>
            </button>
          </div>
        </div>

        <nav>
          <ul className="menu-aside">
            <li className="menu-item">
              <NavLink
                activeClassName="active"
                className="menu-link"
                to="/products"
              >
                <i className="icon fas fa-shopping-bag"></i>
                <span className="text">Products</span>
              </NavLink>
            </li>
            <li className="menu-item">
              <NavLink
                activeClassName="active"
                className="menu-link"
                to="/addproduct"
              >
                <i className="icon fas fa-cart-plus"></i>
                <span className="text">Add product</span>
              </NavLink>
            </li>
            <li className="menu-item">
              <NavLink
                activeClassName="active"
                className="menu-link"
                to="/category"
              >
                <i className="icon fas fa-list"></i>
                <span className="text">Categories</span>
              </NavLink>
            </li>
            <li className="menu-item">
              <NavLink
                activeClassName="active"
                className="menu-link"
                to="/blogs"
              >
                <i className="icon fas fa-blog"></i>
                <span className="text">Blogs</span>
              </NavLink>
            </li>
            <li className="menu-item">
              <NavLink
                activeClassName="active"
                className="menu-link"
                to="/addblog"
              >
                <i className="icon fas fa-pen-alt"></i>
                <span className="text">Add Blog</span>
              </NavLink>
            </li>
            <li className="menu-item">
              <NavLink
                activeClassName="active"
                className="menu-link"
                to="/faqs"
              >
                <i className="icon fas fa-question-circle"></i>
                <span className="text">FAQs</span>
              </NavLink>
            </li>
            <li className="menu-item">
              <NavLink
                activeClassName="active"
                className="menu-link"
                to="/addfaq"
              >
                <i className="icon fas fa-plus-circle"></i>
                <span className="text">Add FAQ</span>
              </NavLink>
            </li>
            <li className="menu-item">
              <NavLink
                activeClassName="active"
                className="menu-link"
                to="/sliders"
              >
                <i className="icon fas fa-sliders-h"></i>
                <span className="text">Sliders</span>
              </NavLink>
            </li>
            <li className="menu-item">
              <NavLink
                activeClassName="active"
                className="menu-link"
                to="/addslider"
              >
                <i className="icon fas fa-layer-plus"></i>
                <span className="text">Add Slider</span>
              </NavLink>
            </li>
            <li className="menu-item">
              <NavLink
                activeClassName="active"
                className="menu-link"
                to="/orders"
              >
                <i className="icon fas fa-bags-shopping"></i>
                <span className="text">Orders</span>
              </NavLink>
            </li>
            <li className="menu-item">
              <NavLink
                activeClassName="active"
                className="menu-link"
                to="/users"
              >
                <i className="icon fas fa-user"></i>
                <span className="text">Users</span>
              </NavLink>
            </li>
          </ul>
        </nav>
      </aside>
    </div>
  );
};

export default Sidebar;
